import { pbx_module_breadcrumbs } from './_module';

const index = pbx_module_breadcrumbs
  .extend('pbx.worksheet.index')
  .add('pbx.breadcrumb.worksheet.index', { name: 'pbx.worksheet.index' });

export const pbx_worksheets_breadcrumbs = [index];
